import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { qmsService } from '../qms.service';
import { messageService } from 'src/app/message.service';
import { forkJoin } from 'rxjs';
import { AuService } from '../au/au.service';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
@Component({
  selector: 'app-risk',
  templateUrl: './risk.component.html',
  styleUrls: ['./risk.component.scss']
})

export class RiskComponent implements OnInit {

  @Input() pagename: any = "";
  @Input() isRiskFieldsActivited: boolean = false;

  isProcessing = false;
  riskList: any = [];
  operationFlag: any;
  calculatedRiskValue: any = {};
  selectedRiskCategory: any;
  dropdownForRiskCategory: any = [];
  riskCategoryDropdown: any = [];
  riskCategoryNameList: any;
  categoryList: any;
  selectedriskCategoryNameValue: any = [];
  popupTitle: string | null = 'title';
  allowAddEdit: boolean = false;
  riskCategorysearchTxt: any;
  riskCategorysearchTxt1: any;
  isriskCategoryOdd: any = null;

  isriskCategoryNameValuesearchTxt: any;
  isriskCategoryNameValuesearchTxt1: any;
  isriskCategoryNameValueOdd: any = null;

  constructor(
    readonly appService: AppService,
    private readonly snackBar: MatSnackBar,
    readonly paginationService: PaginationService,
    readonly dialog: MatDialog,
    readonly qualityService: qmsService,
    readonly message: messageService,
    readonly auService: AuService
  ) { }

  ngOnInit() {
    this.isProcessing = true;

    forkJoin([
      this.appService.getCodeListsByGroup('RISK_CATEGORY'),
      this.appService.getRiskSettingsFromGroup(this.qualityService.selectedGroup, this.qualityService.moduleName)
    ]).subscribe(([riskCategory, riskSettings,]) => {

      this.dropdownForRiskCategory = riskCategory;
      this.riskSettings = riskSettings;

      this.selectBoxForRiskCategory();
      this.setAesthetic();

      this.appService.getRiskByRefNoAndModule(this.getUniqueId(), this.getModuleName()).subscribe((data: any) => {
        this.isProcessing = false;
        this.riskList = data;
        let list1 = [];

        for (const element of this.riskList) {
          let list = this.riskSettings.filter((x: any) => x.riskCategory == element.qmsRisksVwPk.riskCategory);
          if (list.length == 0) {
            list1.push(element);
          }
        }
        console.log(list1);
        for (const element of list1) {
          this.riskSettings.push({
            module: this.qualityService.moduleName,
            riskCategory: element.qmsRisksVwPk.riskCategory,
            idOddValue: true,
            data: element,
            categoryName: element.qmsRisksVwPk.riskCategoryName
          })
        }

        for (let k = 0; k < this.riskSettings.length; k++) {
          this.riskSettings[k].operationFlag = "Add";
          this.riskSettings[k].selectedRiskCategory = null;
          this.riskSettings[k].selectedRiskCategory = this.riskSettings[k].riskCategory;
          this.valueDroupdownMethod(this.riskSettings[k].riskCategory, k, this.riskSettings[k].categoryName ?? null)
          for (const element of this.riskList) {
            if (element.qmsRisksVwPk.riskCategory == this.riskSettings[k].riskCategory) {
              this.riskSettings[k].operationFlag = "Edit"
              if (element.qmsRisksVwPk.riskCategoryName != null) {
                this.riskSettings[k].selectedriskCategoryNameValue = element.qmsRisksVwPk.riskCategoryName;
                this.riskSettings[k].riskCategoryScale = element.riskCategoryScale;
                this.riskSettings[k].comments = element.comments;
              }
            }
          }
        }
        this.isProcessing = false;
        this.calculatedRiskValue = {
          finalRiskScore: (this.pagename == 'findings' || this.pagename == 'PWfinding') ? this.auService.finalRiskScore : this.qualityService.activity.finalRiskScore,
          finalRiskStatus: (this.pagename == 'findings' || this.pagename == 'PWfinding') ? this.auService.finalRiskStatus : this.qualityService.activity.finalRiskStatus,
          finalRiskComments: (this.pagename == 'findings' || this.pagename == 'PWfinding') ? this.auService.finalRiskComments : this.qualityService.activity.finalRiskComments,
        }
        if (this.calculatedRiskValue.finalRiskComments == null) {
          this.disabledComments = false;
        }
      });
    });
    console.log(this.calculatedRiskValue);
  }

  selectBoxForRiskCategory() {
    this.riskCategoryDropdown = [];
    this.riskCategoryDropdown = this.dropdownForRiskCategory?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  getModuleName() {
    let moduleName;

    if (this.pagename == 'findings' || this.pagename == 'PWfinding') {
      moduleName = "AU-FINDINGS";
    } else {
      moduleName = this.qualityService.moduleName;
    }

    return moduleName;
  }

  getUniqueId() {
    let uniqueId;

    if (this.pagename == 'findings') {
      uniqueId = this.auService.findingId;
    } else if (this.pagename == 'PWfinding') {
      uniqueId = this.auService.ParallelWorkflowfindingId;
    } else {
      uniqueId = this.qualityService.activityId;
    }

    return uniqueId;
  }

  getColumnSizes() {
    return "2fr 2fr 2fr 2fr";
  }

  valueDroupdownMethod(data: any, idx: any, categoryName: any) {
    this.riskCategoryNameList = [];
    if (categoryName) {
      this.riskSettings[idx].categoryList = this.riskSettings[idx].riskCategoryNameList = [];
      this.riskSettings[idx].categoryList.push({
        riskCategory: data,
        riskCategoryName: categoryName
      });
      this.riskSettings[idx].riskCategoryNameList.push({
        valueExp: categoryName,
        displayExp: categoryName
      });
      console.log(this.riskSettings[idx]);
    } else {
      this.appService.getriskSettingsByCategoryAndGroup(this.qualityService.selectedGroup, this.qualityService.moduleName, data)
        .subscribe((data1: any) => {
          console.log(data1);
          this.riskSettings[idx].categoryList = this.riskSettings[idx].riskCategoryNameList = [];
          this.riskSettings[idx].categoryList = data1;
          this.riskSettings[idx].riskCategoryNameList = data1?.map((item: any) => ({
            valueExp: item.riskCategoryName,
            displayExp: item.riskCategoryName
          })) ?? [];
          console.log(this.riskSettings[idx]);
        });
    }
  }

  riskSettings: any = [];
  isFrozen: boolean = false;

  setAesthetic() {

    const status = this.qualityService.activity.status;
    const pwStatus = this.qualityService.parallelworkflowStatus;
    const findingStatus = this.qualityService.currentFindings.status;

    const x = findingStatus + '/' + status;

    if (this.qualityService.moduleName == 'AU' && this.pagename != 'findings' && this.pagename != 'PWfinding' && this.auService.isAuditor) {
      this.isFrozen = status == 'Received Q&A Response' || status == 'In Progress/Received Q&A Response' || status == 'Inprogress' || status == 'Peer Review Rejected' ||
        status == 'Peer Reviewer Requested More Info.' || status == 'Closure Review Rejected' || status == 'Closure Reviewer Requested More Info.' ||
        status == 'Closure Approval Rejected' || status == 'Closure Approver Requested More Info.' || status == 'In Progress';
    } else if (this.qualityService.moduleName == 'AU' && this.pagename == 'PWfinding') {
      this.isFrozen = pwStatus == 'Draft' || pwStatus == 'Review Rejected' || pwStatus == 'Reviewer Reqd More Info.' || pwStatus == 'Reviewer Requested More Info.';
    } else if (this.qualityService.moduleName == 'AU' && this.pagename == 'findings') {
      this.isFrozen = x == 'Open/Findings In Progress' || x == 'Response Review Rejected/Findings In Progress' || x == 'Response Verification Rejected/Findings In Progress';
    } else {
      this.isFrozen = this.qualityService.moduleName != 'AU' && this.qualityService.showRiskButtons;
    }

    console.log('isFrozen', this.isFrozen);
  }

  popupDataTitle: any;
  calculateValidation() {
    let hasError = false;

    this.riskSettings.forEach((item: any) => {
      item.isInvalid = false;
    });

    for (const element of this.riskSettings) {
      if (!element.selectedriskCategoryNameValue) {
        element.isInvalid = true;
        hasError = true;
      }
    }

    if (hasError) {
      alert("Please select Risk Name for all entry");
      return;
    }

    let loopReturn: number = 0;
    for (const element of this.riskSettings) {
      this.isProcessing = true;
      console.log(loopReturn);

      let auditObj: any = {
        qmsRisksVwPk: {
          refNo: this.getUniqueId(),
          riskCategory: element.selectedRiskCategory,
          riskCategoryName: element.selectedriskCategoryNameValue,
        },
        groupId: this.qualityService.selectedGroup,
        module: this.getModuleName(),

        riskCategoryScale: element.riskCategoryScale,
        comments: element.comments,
      }
      if (element.operationFlag == "Add") {
        this.appService.createqmsRisksVw(auditObj).subscribe({
          next: (Response: any) => {
            loopReturn = loopReturn + 1;
            console.log(loopReturn, this.riskSettings.length);
            if (loopReturn == this.riskSettings.length) {
              this.calculateRiskBtn();
            }
            this.isProcessing = false;
          },
          error: (error) => {
            loopReturn = loopReturn + 1;
            console.log(loopReturn, this.riskSettings.length);
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        this.appService.updateqmsRisksVw(auditObj).subscribe({
          next: (Response: any) => {
            loopReturn = loopReturn + 1;
            console.log(loopReturn, this.riskSettings.length);
            if (loopReturn == this.riskSettings.length) {
              this.calculateRiskBtn();
            }
            this.isProcessing = false;
          },
          error: (error) => {
            loopReturn = loopReturn + 1;
            console.log(loopReturn, this.riskSettings.length);
            this.isProcessing = false;
            return error;
          }
        });
      }
    }
  };

  disabledComments: boolean = true;;
  calculateRiskBtn() {
    this.isProcessing = true;
    let auditObj: any = {
      qmsRisksVwPk: {
        refNo: this.getUniqueId(),
      },
      module: this.getModuleName(),
      groupId: this.qualityService.selectedGroup
    }
    this.appService.getCalculateFinalRiskSscoreProcedure(auditObj).subscribe({
      next: (Response: any) => {
        if (this.calculatedRiskValue.finalRiskComments == Response.finalRiskComments || (Response.finalRiskComments == null || this.calculatedRiskValue.finalRiskComments == null) || this.calculatedRiskValue.finalRiskComments != Response.finalRiskComments) {
          this.disabledComments = false;
        }

        this.qualityService.activity.finalRiskScore = Response.finalRiskScore;
        this.qualityService.activity.finalRiskStatus = Response.finalRiskStatus;
        this.qualityService.activity.finalRiskComments = Response.finalRiskComments;
        this.calculatedRiskValue.finalRiskScore = Response.finalRiskScore;
        this.calculatedRiskValue.finalRiskStatus = Response.finalRiskStatus;
        this.calculatedRiskValue.finalRiskComments = Response.finalRiskComments;
        this.auService.finalRiskScore = Response.finalRiskScore;
        this.auService.finalRiskStatus = Response.finalRiskStatus;
        this.auService.finalRiskComments = Response.finalRiskComments;
        console.log(this.qualityService.activity.finalRiskStatus);

        if (Response.resultType == "S") {
          this.submitFunction();
        } else {
          this.showSnackBar(Response.result, Response.resultType);
        }

      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    })
  }

  finalRiskCommentsChange(value: any) {
    this.qualityService.activity.finalRiskComments = value;
  }

  savebutton() {
    this.submitFunction();
  }

  submitFunction() {
    this.isProcessing = true;
    let auditObj: any = {
      qmsRisksVwPk: {
        refNo: this.getUniqueId(),
      },

      module: this.getModuleName(),
      finalRiskScore: this.qualityService.activity.finalRiskScore,
      finalRiskStatus: this.qualityService.activity.finalRiskStatus,
      finalRiskComments: this.qualityService.activity.finalRiskComments
    }

    this.appService.getUpdateTaskRiskStatusProcedure(auditObj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.auService.finalRiskScore = this.qualityService.activity.finalRiskScore;
          this.auService.finalRiskStatus = this.qualityService.activity.finalRiskStatus;
          this.auService.finalRiskComments = this.qualityService.activity.finalRiskComments
          this.ngOnInit();
          this.isProcessing = false;
        } else {
          this.isProcessing = false;
        }
        this.showSnackBar(Response.result, Response.resultType);
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    })
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message: message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  onRiskCategorySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedriskCategoryNameValue = [];
      }
    }
  };

  onRiskCategoryDeSelect() { };
  onRiskNameSelect(event: any, item: any, idx: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item.valueExp) {
          const matchingRiskCategory = this.riskSettings[idx].categoryList?.find((item1: any) => item1.riskCategoryName === item.valueExp);
          if (matchingRiskCategory) {
            this.riskSettings[idx].riskCategoryScale = matchingRiskCategory.riskCategoryScale;
            this.riskSettings[idx].comments = matchingRiskCategory.comments;
          }
        }
      }
    }
  };

  public isDisabled(): boolean {
    return this.qualityService.showRiskButtons && this.qualityService.moduleName != 'AU';
  }

  idMapping: Record<string, string> = { 'CR': this?.qualityService?.activity?.crId, 'CAPA': this.qualityService.activity.capaId, 'DV': this.qualityService.activity.dvId, 'AU': this.qualityService.activity.auId, 'IN': this.qualityService.activity.inId, 'QI': this.qualityService.activity.qiId, 'CC': this.qualityService.activity.ccId };

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail() {
    this.message.tableOrView_Name = "QMS_RISKS_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,MODULE,RISK_CATEGORY,RISK_CATEGORY_NAME,RISK_CATEGORY_SCALE,COMMENTS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action_Flag,Module,Risk_Category,Risk_Category_Name,Risk_Category_Scale,Comments,Created_On,Created_By_User,Updated_On,Updated_By_User";
    this.message.whereClause_AU = " AND REF_NO = " + this.message.activityId;
    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action_Flag,Module,Risk_Category,Risk_Category_Name,Risk_Category_Scale,Comments,Created_On,Created_By_User,Updated_On,Updated_By_User";
    this.message.whereClause_Report = " WHERE REF_NO = " + this.message.activityId;
    this.message.report_And_Popup_Name = this.qualityService.moduleName + ' Risk Report [' + this.idMapping[this.qualityService.moduleName] + ']';
    this.staticAuditTrailComponent.triggerTrail(0);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "QMS_RISKS_VW";
    this.excelPdf.columnList_DB = "MODULE,RISK_CATEGORY,RISK_CATEGORY_NAME,RISK_CATEGORY_SCALE,COMMENTS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
    this.excelPdf.columnList_Report = "Module,Risk_Category,Risk_Category_Name,Risk_Category_Scale,Comments,Created_On,Created_By_User,Updated_On,Updated_By_User";
    this.excelPdf.whereClause_Report = " WHERE REF_NO = " + this.message.activityId;
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = this.qualityService.moduleName + ' Risk Report [' + this.idMapping[this.qualityService.moduleName] + ']';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

  focusMethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value); requiredElement?.focus();
    }, 0)
  };
}
